import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Analytics dashboard — 3 frames: metric cards -> article table -> AEO signals.
function ANCards(): JSX.Element {
  return (
    <SimShell step={1} total={3} title="Site overview">
      <div className="grid grid-cols-3 gap-1.5 text-[11px]">
        {[
          ['Clicks', '880', 'text-success'],
          ['Impr.', '12.4k', 'text-purple'],
          ['CTR', '7.1%', 'text-accent'],
          ['Avg pos', '6.3', 'text-warning'],
          ['Articles', '24', 'text-dash-primary'],
        ].map(([label, value, cls]) => (
          <div
            key={label}
            className="rounded border border-dash-border bg-dash-surface px-2 py-1.5"
          >
            <div className="text-dash-muted">{label}</div>
            <div className={'font-mono text-sm ' + cls}>{value}</div>
          </div>
        ))}
      </div>
    </SimShell>
  );
}

function ANTable(): JSX.Element {
  return (
    <SimShell step={2} total={3} title="Per-article table">
      <ul className="space-y-1 text-[11px]">
        {[
          ['Protein timing for runners', '210'],
          ['Carb loading basics', '156'],
          ['Recovery window science', '98'],
        ].map(([t, clicks]) => (
          <li
            key={t}
            className="flex items-center justify-between rounded border border-dash-border bg-dash-surface px-3 py-1"
          >
            <span className="text-dash-primary truncate">{t}</span>
            <span className="font-mono text-dash-secondary">{clicks} clicks</span>
          </li>
        ))}
      </ul>
    </SimShell>
  );
}

function ANSignals(): JSX.Element {
  return (
    <SimShell step={3} total={3} title="AEO signals">
      <div className="rounded border border-dash-border bg-dash-surface p-2 text-[11px]">
        <div className="text-[10px] font-mono uppercase text-dash-muted mb-1">
          Long-tail queries
        </div>
        <ul className="space-y-0.5 text-dash-secondary">
          <li>how long after a run should i eat protein</li>
          <li>is whey or casein better for recovery</li>
        </ul>
        <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
          GSC data lands 2–7 days after publish
        </div>
      </div>
    </SimShell>
  );
}

export function AnalyticsSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <ANCards />, label: 'Site-wide metric cards', duration: D },
        { frame: <ANTable />, label: 'Drill into each article', duration: D },
        { frame: <ANSignals />, label: 'AEO long-tail signals', duration: D },
      ]}
    />
  );
}
